import script from "./addHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./addHistory.vue?vue&type=script&setup=true&lang=ts"

import "./addHistory.vue?vue&type=style&index=0&id=550ec667&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-550ec667"]])

export default __exports__